import colors from "../base/colors";
/** Full-height navigation surface from the merchant reference. */
export default {
  styleOverrides: {
    root: { width: 280, whiteSpace: "nowrap", border: "none" },
    paper: {
      width: 280,
      backgroundColor: colors.surface.main,
      height: "100dvh",
      margin: 0,
      borderRadius: 0,
      border: "none",
    },
    paperAnchorDockedLeft: { borderRight: "1px solid " + colors.grey[300] },
  },
};
